import React, { useContext, useEffect, useRef, useState } from "react";
import ViewerContext from "../../context/ViewerContext";
import {
  Cartesian3,
  NearFarScalar,
} from "cesium";
import { createEntityLabel } from "../../helper/cesiumHelper";

const CreateStationDataSource = () => {
  const { allData } = useContext(ViewerContext);

  useEffect(() => {
    if (allData && allData.hasOwnProperty('rx_stations')) {
      plotGroundStations(allData.rx_stations);
    }
  }, [allData]);

  const plotGroundStations = (rxStationList) => {
    // Plot ground stations
    rxStationList.forEach((station) => {
      const { name, latitude_degn, longitude_dege, altitude_m } =
        station;

      const stationId = `station-${name.trim()}`;
      const stationEntity = viewer.entities.getById(stationId);

      if (!stationEntity) {
        viewer.entities.add({
          id: stationId,
          name,
          type: "station",
          position: Cartesian3.fromDegrees(
            longitude_dege,
            latitude_degn,
            altitude_m
          ),
          label: createEntityLabel({ name: name }),
          // point: {
          //   pixelSize: 10,
          //   color: Color.BLUE,
          // },
          model: {
            uri: "/models/dish.glb",
            // scale: 5.0, // Adjust the scale as needed
            scaleByDistance: new NearFarScalar(3e2, 5, 8.0e6, 1),

            minimumPixelSize: 64,
          },
        });
      }
    });
  };

  return <></>;
};

export default CreateStationDataSource;
